export const DETAILS = 'DETAILS'
export const DEGREE_DETAILS = 'DEGREE_DETAILS'